export default __webpack_public_path__ + "static/media/hz-header-bg.50f3aca8.jpg";